import React, { Component } from 'react';
import { connect } from "react-redux";

import { Row, Col } from 'reactstrap';

import * as actions from '../../actions/ApiActions';

import NumberedItem from '../../components/NumberedItem/NumberedItem'
import Headline from '../../components/Headline/Headline'
import Section from '../../components/Section/Section'
import Button from "../../components/Button/Button";
import Content from "../../components/Content/Content";
import ContactForm from '../../components/ContactForm/ContactForm';
import LogoCarousel from '../../components/LogoCarousel/LogoCarousel';

class DoctorsContainer extends Component {
  constructor(props) {
    super(props);

    this.doctorRef = React.createRef();
    this.patientRef = React.createRef();
  }

  render() {

    const { sendContactMessage } = this.props;

    return (
      <div>
        <Section pattern header>
          <Headline pageTitle>
            Wir haben den passenden Patienten für Sie.
          </Headline>
          <Headline center subtitle>Keine Leerzeiten, optimale Auslastung der Sprechzeiten, <br />Zufriedenheit auf beiden Seiten!</Headline>
        </Section>
        <div>

          <Section triangle ref={this.doctorRef}>
            <Row>
              <Col lg={{ size: 8, offset: 2 }} xs={12}>

                <Row style={{ marginBottom: '80px', marginTop: '-120px' }}>
                  <Col lg={4} xs={12}>
                    <img style={{ height: '250px', width: 'auto', left: '-50px' }}
                         className={'avatar'}
                         src={'/img/avatars/Arzt-1.png'} />
                  </Col>
                  <Col lg={8} xs={12}>
                    <div style={{ background: '#e2e2e2', padding: '25px 20px' }}>
                      <h5>Kurzfristiger Terminausfall</h5>
                      <p>Das ist Dr. Kramer. In seiner Arztpraxis fällt gerade,
                        wie so oft ein Arzttermin kurzfristig aus und er weiß
                        nicht, wie er den Termin selbst neu vermitteln soll.
                        Also beschließt er, sich bei der Terminvergabe von
                        Quickdoctor helfen zu lassen.</p>
                    </div>
                  </Col>
                </Row>

                <Row style={{ marginBottom: '80px' }}>
                  <Col lg={4} xs={12}>
                    <img style={{ height: '250px', width: 'auto', left: '-50px' }}
                         className={'avatar'}
                         src={'/img/avatars/Arzt-2.png'} />
                  </Col>
                  <Col lg={8} xs={12}>
                    <div style={{ background: '#e2e2e2', padding: '25px 20px' }}>
                      <h5>Übermittlung an Quickdoctor</h5>
                      <p>Sobald ein Termin in der Praxis ausfällt, kann er
                        durch eine Schnittstelle mit der Praxissoftware
                        automatisch an Quickdoctor übermittelt werden -
                        ganz einfach und ohne Aufwand.</p>
                    </div>
                  </Col>
                </Row>

                <Row style={{ marginBottom: '80px' }}>
                  <Col lg={4} xs={12}>
                    <img style={{ height: '250px', width: 'auto', left: '-100px' }}
                         className={'avatar'}
                         src={'/img/avatars/Arzt-3.png'} />
                  </Col>
                  <Col lg={8} xs={12}>
                    <div style={{ background: '#e2e2e2', padding: '25px 20px' }}>
                      <h5>Buchung durch Patienten</h5>
                      <p>Nun ist der Termin auf Dr. Kramers Profil der
                        Quickdoctor Online-Platform für alle Patienten
                        einsehbar. Sobald ein Patient den Termin gebucht
                        hat, wird Dr. Kramer benachrichtigt und der Termin
                        automatisch in seinen Terminkalender eingetragen.</p>
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col lg={4} xs={12}>
                    <img style={{ height: '250px', width: 'auto', left: '0' }}
                         className={'avatar'}
                         src={'/img/avatars/Arzt-4.png'} />
                  </Col>
                  <Col lg={8} xs={12}>
                    <div style={{ background: '#e2e2e2', padding: '25px 20px' }}>
                      <h5>Dr. Kramer ist zufrieden</h5>
                      <p>Trotz des kurzfristigen Terminausfalls konnte die
                        Auslastung seiner Praxis gewährleistet werden, und
                        das ganz einfach. Außerdem konnte Dr. Kramer einem Patienten helfen, der sonst so viel längere Wartezeiten in
                        Kauf nehmen müsste.</p>
                    </div>
                  </Col>
                </Row>

              </Col>
            </Row>
          </Section>

          <Section pattern>
            <Headline pageTitle>
              Sind Sie interessiert?
            </Headline>
            <Headline center subtitle>Hier geht es zu unseren Paketen und Preisen.</Headline>
            <Button href={'/pricing'} center>Pakete & Preise</Button>
          </Section>

          <Section>
            <Headline>Unsere Partner und Unterstützer</Headline>
            <LogoCarousel>
              <img src="/img/avatars/logos/logo1.png" />
              <img src="/img/avatars/logos/logo2.png" />
              <img src="/img/avatars/logos/logo3.png" />
              <img src="/img/avatars/logos/logo4.png" />
              <img src="/img/avatars/logos/logo5.png" />
              <img src="/img/avatars/logos/logo6.png" />
              <img src="/img/avatars/logos/logo7.png" />
              <img src="/img/avatars/logos/logo8.png" />
              <img src="/img/avatars/logos/logo9.png" />
            </LogoCarousel>
          </Section>

          <Section grey>
            <Row>
              <Col md={5} xs={12}>
                <Headline>Haben Sie noch Fragen?</Headline>
                <Headline small>Dann kommen Sie mit uns in Kontakt.</Headline>
                <ContactForm sendAction={(body) => sendContactMessage(body)} />
              </Col>

              <Col md={{ size: 5, offset: 1 }} xs={12}>
                <div style={{
                  display: 'flex',
                  width: '100%',
                  height: '100%',
                  justifyContent: 'flex-end',
                  flexDirection: 'column'
                }}>
                  <Headline>Bekannt aus:</Headline>
                  <img src={'/img/bekannt-aus.png'} />
                </div>
              </Col>
            </Row>

          </Section>

        </div>
      </div>
    )
  }
}

export default connect(null, actions)(DoctorsContainer);



// WEBPACK FOOTER //
// ./src/container/public/DoctorsContainer.js